import { render } from "./Aside.vue?vue&type=template&id=2c81e3f2&scoped=true"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"

import "./Aside.vue?vue&type=style&index=0&id=2c81e3f2&scoped=true&lang=css"

import exportComponent from "/tmp/workdir/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c81e3f2"]])

export default __exports__